import { useEffect, useState } from 'react';

const useMemberLeft = ({ channelInformation }) => {
  const [message, setMesasge] = useState();

  useEffect(() => {
    if (channelInformation !== null) {
      channelInformation.on('messageAdded', message => {
        setMesasge(message);
      })
    }

    //eslint-disable-next-line
  }, [channelInformation])

  return { message };
}

export default useMemberLeft;
